import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, DestructiveOperationModal, Alert) {
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.$state = $state;
        this.Alert = Alert;
    }

    $onInit() {
        this.stAdministrators = new SmartTable();
        this.stDirectories = new SmartTable();

        this.administrators = this.cmpDetail.administrators;
        this.directories = this.cmpDetail.directories;
        this.domains = this.cmpDetail.domains;
        this.company = this.cmp.company;
    }

    deleteCompany() {
        const companyId = this.$state.params.companyId;
        const cmpId = this.cmpDetail.companyId;
        const url = `app/rest/v2/company/${companyId}/saaspassadmin/company/${cmpId}`;
        this.DestructiveOperationModal({
            titleKey: 'global.confirm_delete',
            textKey: 'Company and all related data will be deleted. This action can not be undone. <br><br>Are you sure you want to permanantly delete this company?',
            http: {method: 'DELETE', url}
        }).then(() => {
            this.Alert('success', 'Company and all related data is deleted');
            this.$state.go('^', {}, {reload: '^'});
        });
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/details/company-details.controller.js